import { render, staticRenderFns } from "./DataManager.vue?vue&type=template&id=03eb69d0&scoped=true&"
import script from "./DataManager.vue?vue&type=script&lang=js&"
export * from "./DataManager.vue?vue&type=script&lang=js&"
import style0 from "./DataManager.vue?vue&type=style&index=0&id=03eb69d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb69d0",
  null
  
)

export default component.exports